// Spanish copy — Kelo Diamonds
const es = {
  code: "es",
  announcement: "Joyería premium de moissanita · Atención personalizada para tu pedido",
  nav: {
    shop: "Comprar",
    bestSellers: "Más vendidos",
    sizeGuide: "Guía de tamaños",
    whyMoissanite: "Por qué moissanita",
    ourStory: "Nuestra historia",
    faq: "Preguntas frecuentes",
    cart: "Carrito",
    menu: "Menú",
  },
  hero: {
    eyebrow: "KELO DIAMONDS",
    headline: "Built Under Pressure.",
    tagline: "Moissanita VVS de la más alta calidad. Brillo real. Lujo inteligente.",
    scrollCue: "DESCUBRE MÁS",
  },
  trust: ["Plata esterlina 925", "Moissanita VVS", "Se vende como un par completo", "Caja de regalo premium", "Atención personalizada"],
  flagship: {
    eyebrow: "Producto estrella",
    statement:
      "Un par refinado de aretes de moissanita VVS de corte redondo, montados en plata esterlina 925 y diseñados para ofrecer un brillo visual excepcional.",
    chooseSize: "Tamaño",
    soldAsPair: "Se vende como un par completo",
    quantity: "Cantidad",
    unitPrice: "Precio unitario",
    addToCart: "Agregar al carrito",
    added: "Agregado al carrito",
    buy: "Pedir ahora",
    whatsapp: "WhatsApp",
    includedTitle: "Todo lo que incluye tu par",
    included: [
      "Dos aretes de moissanita a juego",
      "Claridad VVS · Color D",
      "Plata esterlina 925, montura de cuatro garras",
      "El tamaño CTW que elijas",
      "Caja de regalo premium",
      "Instrucciones de cuidado",
      "Atención personalizada para tu pedido",
    ],
    specsTitle: "Detalles del producto",
    specs: [
      ["Piedra", "Moissanita"],
      ["Corte", "Redondo"],
      ["Claridad", "VVS"],
      ["Color", "Color D"],
      ["Metal", "Plata esterlina 925"],
      ["Montura", "Cuatro garras"],
      ["Se vende", "Un par completo"],
      ["Empaque", "Caja de regalo premium"],
    ],
    ctwTitle: "Entender el CTW",
    ctwNote: "CTW representa el tamaño equivalente total combinado de ambos aretes.",
  },
  collection: {
    title: "Explora la colección",
    subtitle: "Tres diseños refinados, cada uno en plata esterlina 925.",
    viewDetails: "Ver detalles",
    buy: "Pedir",
  },
  sizeGuide: {
    title: "Guía de tamaños",
    subtitle: "Elige la presencia que va con tu estilo.",
    total: "Total (ambos aretes)",
    perEarring: "Por arete",
    note: "La guía visual es aproximada. El tamaño percibido puede variar según la pantalla y la anatomía de cada persona.",
    help: "¿Necesitas ayuda para elegir el tamaño?",
    videoLabel: "Video · Guía visual",
    videoAria: "Reproducir video de la guía de tamaños",
    styles: {
      "1ctw": "Discreto y refinado.",
      "2ctw": "Equilibrado para uso diario.",
      "3ctw": "Visiblemente llamativo.",
      "4ctw": "Una presencia visual fuerte.",
    },
    styleShort: {
      "1ctw": "Discreto",
      "2ctw": "Equilibrado",
      "3ctw": "Llamativo",
      "4ctw": "Presencia fuerte",
    },
  },
  why: {
    title: "Por qué moissanita",
    subtitle: "Una piedra premium con ventajas propias.",
    benefits: [
      ["Brillo", "Fuego y destellos excepcionales bajo cualquier luz."],
      ["Durabilidad", "9.25 en la escala de Mohs — ideal para uso frecuente con el cuidado adecuado."],
      ["Apariencia premium", "Un aspecto refinado y de alta gama que llama la atención."],
      ["Excelente valor", "Una presencia notable por una fracción del costo."],
    ],
    comparisonTitle: "Una comparación honesta",
    comparison: {
      headers: ["", "Diamante natural", "Moissanita"],
      rows: [
        ["Tipo de piedra", "Cristal de carbono", "Carburo de silicio"],
        ["Brillo visual", "Brillo elegante", "Más fuego y destellos"],
        ["Durabilidad", "10 Mohs", "9.25 Mohs"],
        ["Precio relativo", "Miles de dólares", "Una fracción del costo"],
        ["Cuidado", "Cuidado estándar", "Cuidado estándar"],
      ],
      note: "La moissanita es una piedra propia con una belleza distinta. No es un diamante y nunca la presentamos como tal.",
    },
  },
  macro: { title: "Cada detalle importa.", support: "Diseñados para apreciarse desde todos los ángulos." },
  story: {
    eyebrow: "La historia del producto",
    infoTitle: "Cada par incluye",
    infoItems: [
      "Claridad VVS",
      "Color D",
      "Plata esterlina 925",
      "Caja de regalo premium",
      "Soporte de por vida",
    ],
    slides: [
      { headline: "Brillo que se puede ver.", sub: "Creado para llamar la atención." },
      { headline: "Pasa la prueba del diamond tester.", sub: "Probado mediante conductividad térmica." },
      { headline: "Claridad VVS.", sub: "Claridad excepcional en cada piedra." },
      { headline: "Color D.", sub: "Una apariencia brillante e incolora." },
      { headline: "Plata esterlina 925.", sub: "Creado para el uso diario." },
      { headline: "Presentación premium.", sub: "Cada par llega listo para regalar." },
      { headline: "Diseñado para destacar.", sub: "Elige tu tamaño perfecto.", cta: "Explorar tamaños" },
    ],
    aria: {
      prev: "Historia anterior",
      next: "Siguiente historia",
      pause: "Pausar",
      play: "Reproducir",
    },
    share: {
      button: "Compartir",
      title: "Compartir esta historia",
      channels: {
        whatsapp: "WhatsApp",
        twitter: "X (Twitter)",
        facebook: "Facebook",
        copy: "Copiar enlace",
        copied: "¡Copiado!",
      },
      text: "Mira esto — Kelo Diamonds",
    },
  },
  quality: {
    title: "Elaborado con atención al detalle",
    blocks: [
      ["Moissanita VVS", "Alta claridad para una piedra limpia y brillante."],
      ["Color D", "El grado más alto e incoloro."],
      ["Corte redondo", "Un corte atemporal pensado para el brillo."],
      ["Plata esterlina 925", "Monturas de plata de ley auténtica."],
      ["Montura de cuatro garras", "Sujeción segura que deja pasar la luz."],
      ["Se vende en par", "Dos aretes a juego, siempre."],
    ],
  },
  packaging: {
    title: "Lista para regalar. Diseñada para conservar.",
    text: "Cada par llega en una caja de regalo premium, lista para obsequiar o conservar.",
  },
  howOrder: {
    title: "Cómo funciona el pedido",
    steps: [
      ["Elige tu estilo", "Selecciona el diseño de aretes que prefieras."],
      ["Selecciona tu tamaño", "Compara 1 CTW, 2 CTW, 3 CTW y 4 CTW."],
      ["Envía tu pedido", "El producto, tamaño, cantidad y precio se preparan automáticamente."],
      ["Confirma con nuestro equipo", "Completa disponibilidad, pago y entrega por WhatsApp."],
    ],
    note: "Tu pedido queda confirmado después de que nuestro equipo valide la disponibilidad, el pago y los detalles de entrega.",
    cta: "Completa tu pedido con atención personalizada",
  },
  shipping: {
    title: "Envíos y atención al cliente",
    text: "El tiempo de entrega y las opciones disponibles se confirman antes del pago. Una persona real te acompaña antes y después de tu pedido.",
    supportTitle: "Habla con una persona real",
    contact: "Escríbenos por WhatsApp",
  },
  founder: {
    eyebrow: "Nuestra historia",
    title: "Personas reales detrás de cada par.",
    videoLabel: "Video · Presentación",
    videoAria: "Reproducir video de presentación",
    body: [
      "Kelo Diamonds nació con una idea muy simple: la joyería premium debe sentirse excepcional, transparente y cercana.",
      "Creemos que cada cliente merece saber exactamente lo que está comprando. Por eso presentamos cada producto con especificaciones claras, imágenes reales, información transparente sobre los tamaños y atención directa antes y después de la compra.",
      "Nuestro objetivo no es solamente vender joyería. Es que cada cliente se sienta completamente seguro antes de realizar un pedido.",
    ],
    signature: "— El equipo de Kelo Diamonds",
  },
  reviews: {
    eyebrow: "Clientes",
    title: "Lo que dicen quienes ya usan Kelo.",
    subtitle: "Reseñas verificadas de clientes reales.",
    verified: "Compra verificada",
    ratingLabel: (r) => `${r} de 5`,
  },
  lead: {
    eyebrowStep1: "Lista privada",
    eyebrowStep2: "Casi listo",
    title: "Obtén $10 en tu primera compra.",
    subtitle: "Recibe tu descuento privado y acceso anticipado a nuevos lanzamientos KELO DIAMONDS.",
    step1Question: "¿A dónde te envío tu oferta?",
    step2Question: "Casi listo — dinos tu nombre y el otro contacto.",
    firstNameLabel: "Nombre",
    firstNamePlaceholder: "Tu nombre",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "tu@correo.com",
    phoneLabel: "Teléfono",
    phonePlaceholder: "+52 555 000 0000",
    ctaStep1: "Continuar",
    ctaStep2: "Obtener mi $10 de descuento",
    stepIndicator: (n) => `Paso ${n} de 2`,
    back: "Atrás",
    close: "Cerrar",
    consent:
      "Al enviar, aceptas recibir correos y ocasionalmente SMS de KELO DIAMONDS. Pueden aplicar cargos. Responde STOP para darte de baja.",
    privacy: "Política de privacidad",
    terms: "Términos",
    errorEmail: "Ingresa un correo válido.",
    errorPhone: "Ingresa un teléfono válido.",
    errorName: "Ingresa tu nombre.",
    errorContact: "Ingresa correo o teléfono.",
    errorGeneric: "No pudimos guardar tus datos. Inténtalo de nuevo en un momento.",
    successTitle: "¡Estás dentro!",
    successSubtitle: "Usa este código en tu primera compra:",
    successCode: "WELCOME10",
    successNote: "Revisamos tu correo para confirmar. También te lo enviamos.",
    copy: "Copiar código",
    copied: "¡Copiado!",
    shopCta: "Ver la colección",
    continueCta: "Seguir viendo",
    footerCta: "Únete a la lista privada",
    footerNote: "$10 en tu primera compra + acceso anticipado.",
  },
  faq: {
    title: "Preguntas frecuentes",
    items: [
      ["¿Qué es la moissanita?", "La moissanita es una piedra premium (carburo de silicio) conocida por su brillo y durabilidad excepcionales. No es un diamante."],
      ["¿Qué significa CTW?", "CTW es el tamaño equivalente total combinado de ambos aretes; por ejemplo, 2 CTW equivale a aproximadamente 1 CT por arete."],
      ["¿Los aretes se venden en par?", "Sí. Cada pedido incluye un par completo a juego."],
      ["¿De qué material están hechos?", "Las monturas son de plata esterlina 925 auténtica con montura de cuatro garras."],
      ["¿La moissanita pierde el brillo?", "Con el cuidado adecuado, la moissanita mantiene su brillo con el tiempo."],
      ["¿Puedo usarlos todos los días?", "Sí, con un cuidado estándar son ideales para uso frecuente."],
      ["¿Cómo debo limpiarlos?", "Usa jabón suave, agua tibia y un paño suave. Evita químicos agresivos."],
      ["¿Cómo elijo el tamaño?", "Usa nuestra guía de tamaños o escríbenos por WhatsApp para una recomendación personalizada."],
      ["¿Cómo funciona el pedido?", "Elige estilo, tamaño y cantidad, y completa tu pedido por WhatsApp donde nuestro equipo confirma los detalles."],
      ["¿Cuánto tarda el envío?", "El tiempo y las opciones de entrega se confirman con nuestro equipo antes del pago."],
      ["¿Puedo hablar con alguien antes de comprar?", "Por supuesto. Escríbenos por WhatsApp cuando quieras antes de hacer tu pedido."],
    ],
  },
  finalCta: { title: "Encuentra el par perfecto.", subtitle: "Lujo cotidiano y refinado, para usar con confianza.", primary: "Comprar Classic Studs", whatsapp: "Pedir por WhatsApp" },
  footer: {
    statement: "Joyería premium de moissanita, presentada con claridad y atención personalizada.",
    shop: "Comprar",
    bestSellers: "Más vendidos",
    sizeGuide: "Guía de tamaños",
    faq: "Preguntas frecuentes",
    shipping: "Envíos",
    privacy: "Política de privacidad",
    terms: "Términos",
    contact: "Contacto",
    rights: "Todos los derechos reservados.",
  },
  cart: {
    title: "Tu carrito",
    empty: "Tu carrito está vacío.",
    emptyHint: "Una obra maestra te espera.",
    item: "artículo",
    items: "artículos",
    moreItem: "artículo más",
    moreItems: "artículos más",
    view: "Ver carrito",
    size: "Tamaño",
    qty: "Cant.",
    subtotal: "Subtotal",
    total: "Total",
    checkout: "Completar pedido por WhatsApp",
    remove: "Quitar",
    clear: "Vaciar carrito",
    shippingNote: "El costo de envío y los detalles finales de entrega serán confirmados por nuestro equipo.",
  },
  whatsapp: {
    order: (lines, total) =>
      `Hola, Kelo Diamonds.\n\nMe gustaría realizar un pedido con los siguientes detalles:\n\n${lines}\n\nTotal del pedido: ${total} USD\n\nPor favor, confírmenme la disponibilidad, las opciones de pago y la información de entrega.`,
    line: ({ name, size, qty, unit }) =>
      `Producto: ${name}\nTamaño: ${size}\nCantidad: ${qty}\nPrecio unitario: ${unit} USD`,
    consult: "Hola, Kelo Diamonds. Me gustaría ayuda para elegir el tamaño correcto de los aretes de moissanita. ¿Podrían asesorarme?",
    support: "Hola, Kelo Diamonds. Tengo una pregunta antes de realizar mi pedido.",
    hint: "¿Te ayudamos a elegir?",
  },
  products: {
    classic: { name: "Aretes Classic de moissanita", short: "El clásico atemporal de corte redondo." },
    halo: { name: "Aretes Halo de moissanita", short: "Un halo de brillo alrededor de la piedra." },
    princess: { name: "Aretes Princess de moissanita", short: "Líneas modernas de corte princesa." },
  },
  product: {
    breadcrumbHome: "Inicio",
    back: "Atrás",
    backHome: "Volver a la tienda",
    notFound: "Producto no encontrado",
    related: "También te puede gustar",
    includes: "Lo que incluye",
    stone: "Piedra",
    cut: "Corte",
    metal: "Metal",
    backing: "Sujeción",
    adding: "Añadiendo…",
    selectSizeFirst: "Selecciona un tamaño antes de añadir.",
    addError: "No se pudo añadir. Inténtalo de nuevo.",
    soldOut: "Agotado",
    specs: {
      classic: { stone: "Moissanita VVS", cut: "Brillante redondo", metal: "Plata esterlina 925", backing: "Rosca (screw-back)" },
      halo:    { stone: "Moissanita VVS", cut: "Redondo + halo pavé", metal: "Plata esterlina 925", backing: "Rosca (screw-back)" },
      princess:{ stone: "Moissanita VVS", cut: "Princess", metal: "Plata esterlina 925", backing: "Rosca (screw-back)" },
      default: { stone: "Moissanita VVS", cut: "Brillante redondo", metal: "Plata esterlina 925", backing: "Rosca (screw-back)" },
    },
  },
  lang: { en: "English", es: "Español" },
};

export default es;
